import React, { useCallback, useEffect, useState } from 'react'
import './account-cards.css'
import PortfolioService from '../../../services/portfolio.service'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAccountListSelector,
  getCurrentAccDetailsSelector,
  isAccountRefreshSelector,
} from '../../../store/selectors/app.selector'
import {
  setAccounts,
  setCurrentAccDetails,
  setIsAcctRefresh,
} from '../../../store/actions/app.actions'
import NumberFormat from 'react-number-format'
// import AddIcon from "../../assets/new-design/Add.svg";
import { useHistory } from 'react-router'
import AccountCardLoader from '../../../content-loader/account-loader'
import SelectedAccountSection from '../../../components/SelectedAccountSection/SelectedAccountSection'
import { useTranslation } from 'react-i18next'
import { ACCOUNT_CARD_KEYS } from '../../../utils/translation-constants'
// import HandyBankLogo from 'custom/assets/logo/IZB-LOGO-SMALL.svg'
export default function AccountCards() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [selectedAccount, setSelectedAccount] = useState({})
  const [accountList, setAccountList] = useState([])
  const accounts = useSelector(getAccountListSelector) || []
  const accountDetails = useSelector(getCurrentAccDetailsSelector) || {}
  const isAccRefresh = useSelector(isAccountRefreshSelector) || {}
  const [showSelectedAccountInfo, setShowSelectedAccountInfo] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    getAccountDetails()
  }, [])

  const getAccountDetails = useCallback(async () => {
    try {
      if (accounts.length === 0 || isAccRefresh === true) {
        const response = await PortfolioService.getAccountDetails({
          accountType: 'S',
        })
        if (response.status === 200) {
          const casaAccountList = response.data['accountSummaryDetails']

          if (casaAccountList.length > 0) {
            setSelectedAccount(casaAccountList[0])
            dispatch(setIsAcctRefresh(false))
            dispatch(setCurrentAccDetails(casaAccountList[0]))

            const accountListCopy = [
              ...casaAccountList.filter((acc) => acc.accountNo !== casaAccountList[0].accountNo),
            ]
            setAccountList(accountListCopy)
            dispatch(setAccounts(casaAccountList))
          }
        }
      } else {
        if (accounts?.length > 0) {
          const accountListCopy = [
            ...accounts.filter((acc) => acc?.accountNo !== accountDetails?.accountNo),
          ]
          setAccountList(accounts?.length === 1 ? [] : accountListCopy)
          setSelectedAccount(accountDetails)
        }
      }
    } catch (err) {}
  }, [])

  const handleAccount = useCallback(
    (selected) => {
      const accountListCopy = [...accountList.filter((acc) => acc.accountNo !== selected.accountNo)]
      accountListCopy.push(selectedAccount)
      setAccountList(accountListCopy)
      setSelectedAccount(selected)
      dispatch(setCurrentAccDetails(selected))
      // dispatch(setCarouselItems(accountListCopy))
    },
    [accountList, selectedAccount],
  )

  return (
    <div style={{ width: 300 }}>
      {Object.keys(selectedAccount).length === 0 && <AccountCardLoader />}

      {Object.keys(selectedAccount).length > 0 && (
        <>
          <div
            className='account-selected-card d-flex flex-column justify-content-around cursor-pointer'
            onClick={() => setShowSelectedAccountInfo(!showSelectedAccountInfo)}>
            <div className='d-flex justify-content-between'>
              {/* <div>
                <h6 style={{ margin: 0, color: '#fff' }}>{t(ACCOUNT_CARD_KEYS.CLIENT_NAME)}</h6> */}
              {/* <img src={VisaLogo} alt='visa' className='' height={11} /> */}
              {/* VISA */}
              {/* </div> */}
            </div>

            <div className=''>
              <span className='mr-2 account-number'> {t(ACCOUNT_CARD_KEYS.ACC_NO)}</span>
              <NumberFormat
                className='account-number'
                value={selectedAccount?.accountNo}
                displayType={'text'}
                format='#### #### #### #####'
              />
            </div>

            <div className='position-relative mt-2'>
              <div className='balance-label'>{t(ACCOUNT_CARD_KEYS.CURRENT_BALANCE)}</div>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <span className='font-weight-500 pr-1' style={{ fontSize: 9 }}>
                    {selectedAccount.currency}
                  </span>
                  <NumberFormat
                    className='balance'
                    value={selectedAccount?.currBal}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
              </div>
            </div>

            <div className='position-relative'>
              <div className='balance-label'>{t(ACCOUNT_CARD_KEYS.AVAILABLE_BALANCE)}</div>
              <div className='d-flex justify-content-between align-items-center'>
                <div>
                  <span className='font-weight-500 pr-1' style={{ fontSize: 9 }}>
                    {selectedAccount.currency}
                  </span>
                  <NumberFormat
                    className='balance'
                    value={selectedAccount?.avlBal}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
              </div>
            </div>
          </div>
          {showSelectedAccountInfo && (
            <div
              className='mx-auto'
              style={{
                width: 300,
                borderRadius: 10,
              }}>
              <SelectedAccountSection
                selectedAccount={selectedAccount}
                close={() => setShowSelectedAccountInfo(false)}
              />
            </div>
          )}
          <div className='account-card-desc'>{t(ACCOUNT_CARD_KEYS.ACCOUNT_CARD_DESCRIPTION)}</div>

          {/* <div className='open-account-card d-flex flex-column justify-content-center'>
            <div
              className="d-flex justify-content-center cursor-pointer"
              onClick={() => history.push("/add-account")}
            >
              <div className="mr-3">
                <img src={AddIcon} alt={"add icon"} className="" />
              </div>
              <div className="my-auto">
                <div className="title font-weight-bold">Open Account</div>
                <div className="content font-weight-500">
                  Open Account description
                </div>
              </div>
            </div>
          </div> */}

          <div>
            {accountList.map((account, index) => (
              <div key={index} className='account-card'>
                <div className='accounts-detail' onClick={() => handleAccount(account)}>
                  <span className='label'>
                    {/* {account.accountType === 'U' ? 'Current Account' : 'Saving Accounts'} */}
                    {account.accountNo}
                  </span>
                  <div className='d-flex justify-content-between mt-2'>
                    <div className='balance'>
                      <label>{t(ACCOUNT_CARD_KEYS.CURRENT_ACCOUNT)}</label>
                      <div>
                        <NumberFormat
                          value={account?.currBal}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                    </div>
                    <div className='balance'>
                      <label>{t(ACCOUNT_CARD_KEYS.AVAILABLE_ACCOUNT)}</label>

                      <div>
                        <NumberFormat
                          value={account?.avlBal}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
